import React, { useCallback } from 'react'
import { FormTable, TableHeader, TableRow } from '@front/squirtle'

import Header from './Header'
import Row from './Row'

const Orders = ({ voucher_id }) =>
  <FormTable
    model_name={'order'}
    config={{
      populate: [
        'voucher',
        'do.commercial_formula',
        'do.customerinfo',
        'do.info',
        'service.contract.company',
        'service.contract.formula',
      ],
      initial_filter: { voucher: voucher_id },
      forced_filter: {
        voucher: voucher_id,
        status: { '!': 'canceled' }
      },
      validate_filter: useCallback(() => !!voucher_id, [voucher_id]),
      watchers: [voucher_id],
      sort: ['service DESC', 'do DESC', 'requestedAt DESC']
    }}
    tableProps={{
      enablePagination: true,
      onRowClick: null,
    }}
  >
    <TableHeader><Header /></TableHeader>
    <TableRow><Row /></TableRow>
  </FormTable>

export default Orders
